import { Box } from '@everlywell/ui-kit';
import RichTextWrapper from 'components/RichTextWrapper';
import React from 'react';
import { ContentfulRichText } from 'utils/contentful/renderRichText';

export type DisclaimerSectionProps = {
  disclaimer: ContentfulRichText | null;
};

const DisclaimerSection = ({ disclaimer }: DisclaimerSectionProps) => {
  if (!disclaimer) return null;

  return (
    <Box
      paddingX={[6, 10, 12]}
      maxWidth="1000px"
      marginTop={[6, 12]}
      marginLeft="auto"
      marginRight="auto"
      sx={{
        padding: {
          color: 'tints.uiGrey',
          textAlign: 'center',
          fontSize: 'sm',
        },
      }}
    >
      <RichTextWrapper contentfulRichText={disclaimer}></RichTextWrapper>
    </Box>
  );
};

export default DisclaimerSection;
